// Pricing.js
import React from "react";
import "./Pricing.css";
import { useNavigate } from "react-router-dom";

export default function Pricing() {
  const navigate = useNavigate();

  const tiers = [
    {
      id: "intensive",
      title: "Intensive Interview Package",
      price: "$375 CAD, save the HST",
      description:
        "Includes 3 hours of 1‑on‑1 virtual coaching (split to fit your schedule) plus comprehensive prep materials.",
      bullets: [
        "Session on your specific interview challenges or questions",
        "Curated list of interview questions",
        "Detailed debrief notes from your mock interviews",
      ],
      note: "Ideal for in‑depth preparation, structure & accountability.",
      paperbellId: "153971",
    },
    {
      id: "single",
      title: "Single Coaching Session",
      price: "$125 CAD + HST / hour",
      description: "Perfect for a quick tune‑up or focused support.",
      bullets: [
        "Personalized onboarding questionnaire",
        "Focused 1‑hour private virtual session on your specific interview challenges or questions",
      ],
      paperbellId: "153290",
    },
   
  ];

  return (
    <div className="pricing-page">
      <h1 className="pricing-heading">Pricing</h1>
      <p className="pricing-intro">
        Bulletproof Interviewing offers flexible coaching options to suit your needs. All the options below are available in person.
      </p>

      <div className="tier-grid">
        {tiers.map((tier) => (
          <div key={tier.id} className="tier-card">
            <h2 className="tier-title">{tier.title}</h2>
            <p className="tier-price">{tier.price}</p>
            <p className="tier-desc">{tier.description}</p>
            <ul className="tier-list">
              {tier.bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
            {tier.note && <p className="tier-note">{tier.note}</p>}
            <button
              className="tier-btn"
              onClick={() => navigate(`/booking/${tier.paperbellId}`)}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>

      <div className="cta">
        <h3>Not Sure Which Option Is Right for You?</h3>
        <p>
          Contact me for a <strong>free consultation</strong> or to ask any questions before
          booking.
        </p>
        <button className="cta-btn" onClick={() => navigate("/contact")}>
          Contact Us
        </button>
      </div>
    </div>
  );
}
